import React from 'react';

interface ForwardLastMessageProps {
	message: any;
	chat: any;
	userId: number;
}

const ForwardLastMessage: React.FC<ForwardLastMessageProps> = ({ message, chat, userId }) => {
	return (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<div>
				{ message.userId === userId ? `You: ${message.text}` : message.text }
			</div>
			<div style={{
				display: 'flex',
				borderRadius: '0.25rem',
				backgroundColor: 'aliceblue',
				padding: '0 0.5rem',
				fontSize: '12px',
				alignItems: 'center',
				marginLeft: '0.5rem',
			}}
			>
				Forwarded
			</div>
		</div>
	);
};

export default ForwardLastMessage;
